var _path;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }

import * as React from "react";

function SvgNotEqual(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4a41c5",
    d: "m6.7647 8.9718c2.0177 0 4.0054-0.00998 6.0231-0.00998l1.4363-2.3681 1.7094 1.0382-0.80976 1.3348 2.2268 0.00499v2h-3.4447l-1.5872 2.6254 5.032-0.0043v2l-6.2528 0.0038-1.5525 2.553-1.7094-1.0382 0.91893-1.5086-1.9901-0.01v-1.9999l3.208-0.0057 1.5972-2.6155h-4.8052m-1.7647-7.9718c-1.11 0-2 0.9-2 2v14c0 1.1046 0.89543 2 2 2h14c1.1046 0 2-0.89543 2-2v-14c0-1.1046-0.89543-2-2-2z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotEqual);
export default __webpack_public_path__ + "static/media/not-equal.f25cfe85a3e7d94495fed4cc33348aa3.svg";
export { ForwardRef as ReactComponent };